// extracted by mini-css-extract-plugin
module.exports = {"modal_center":"DangKyDichVuDetailMoal_modal_center__29nMZ","tool_bar":"DangKyDichVuDetailMoal_tool_bar__PU2j2","text":"DangKyDichVuDetailMoal_text__2YITf"};